const languageResource = {
  DE: {
    backBtn: 'Zurück',
    closeBtn: 'Schließen',
    OkBtn: 'OK',
    cancelBtn: 'Stornieren',
    closethis: 'Schließ das',
    doneBtn:'Auswählen',
    addCommentBtn: 'Kommentar schreiben',
    comment: 'Kommentare',
    nameLbl: 'Name',
    emailLbl: 'E-Mail-Adresse',
    commentLbl: 'Kommentar schreiben...',
    saveCommentbtn: 'Kommentar senden',
    errorCommentTitle: 'BITTE ALLE FELDER AUSFÜLLEN',
    errorCommentMessageName: 'Bitte Namen eingeben',
    errorCommentMessageEmail: 'Bitte E-Mail eingeben',
    errorCommentMessageValidEmail: 'Bitte eine gültige E-Mail-Adresse eingeben!',
    errorCommentMessageValidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein!',
    errorCommentMessageComment: 'Bitte Kommentar eingeben',
    succesCommentTitle: 'KOMMENTAR HINZUGEFÜGT',
    succesTitle: 'Erfolg',
    registrationTitle: 'Benutzer Registration',
    userprofileTitle: 'Benutzer Profil',
    succesMessage: 'Erfolgreich registriert!',
    loginsuccesMessage: 'Sie haben sich erfolgreich angemeldet',
    registrationBtn: 'Registrieren',
    succesCommentMessage: 'Der Kommentar wurde erfolgreich hinzugefügt!',
    map: 'Karte',
    list: 'Liste',
    sendMail: 'E-Mail senden',
    startCall: 'Anruf starten',
    ofText: 'von',
    likeSuccesTitle: 'LIKE HINZUGEFÜGT',
    likeSuccesMessage: 'Dieser Inhalt wurde erfolgreich geliked!',
    disLikeSuccesTitle: 'LIKE ENTFERNT',
    disLikeSuccesMessage: 'Das Like dieses Inhalts wurde erfolgreich entfernt!',
    submitBtn: 'Submit',
    warningTitle: 'Gerätesimulator',
    warningMessage: 'Diese Aktion kann nur auf einem echten Gerät getestet werden. Lade hierzu einfach die ON AIR Cockpit-App auf dein Gerät, die du in deinem App-Store erhältst.',
    AppleDownload: ' Zum Apple App-Store...',
    AndroidDownload: 'Zum Google Play Store...',
    readMoreBtn: 'Weiterlesen...',
    today: 'Heute',
    yesterday: 'Gestern',
    textInput:
    {
      "label": "Beschriftung",
      "placeholder": "Geben Sie hier Ihren Text ein"
    },
    emailInput:
    {
      "label": "E-Mail-Adresse",
      "placeholder": "Geben Sie hier Ihre E-Mail ein"
    },
    phoneInput:
    {
      "label": "Telefonnummer",
      "placeholder": "Geben Sie hier Ihre Telefon-Nr. ein"
    },
    urlInput:
    {
      "label": "Webseite",
      "placeholder": "Geben Sie hier Ihre Webadresse ein"
    },
    dateInput:
    {
      "label": "Datum",
      "placeholder": "Wählen Sie hier das Datum aus"
    },
    timeInput:
    {
      "label": "Uhrzeit",
      "placeholder": "Wählen Sie hier die Uhrzeit aus"
    },
    memoinput:
    {
      "label": "Ihre Nachricht",
      "placeholder": "Geben Sie hier Ihre Nachricht ein"
    },
    switchinput:
    {
      "label": "Bitte wählen Sie aus:"
    },
    selectioninput:
    {
      "label": "Bitte wählen Sie aus",
      "placeholder": "Hier klicken, um auszuwählen"
    },
    checkboxinput:
    {
      "label": "Bitte wählen Sie aus"
    },
    radioinput:
    {
      "label": "Bitte wählen Sie aus"
    },
    strPostOn: 'Veröffentlicht am',
    strReply: 'Antwort',
    strReplies: 'Antworten',
    strViews: 'Aufrufe',
    strShow: 'anzeigen',
    nofbdata: 'Momentan sind keine FaceBook Seiten verfügbar',
    nofbcomments: 'Es gibt keine FaceBook-Kommentare',
    nowebsitedata: 'Zur Zeit sind keine Webseiten verfügbar',
    norssdata: 'Derzeit sind RSS-Felder verfügbar',
    noyoutubedata: 'Zur Zeit sind keine Kanäle verfügbar',
    strPastEvent: 'Vergangene Termine/Events',
    strFutureEvent: 'Zukünftige Termine/Events',
    strCurrentEvent: 'Laufend Termine/Events',
    RobotMessage1: 'Willkommen zum Modul Chat',
    RobotMessage2: 'Hallo',
    RobotMessage3: 'Hier kannst du die Chat Nachrichten deiner User sehen',
    sendmessageplaceholder: "Nachricht senden",
    userBannedSendMsg: "Sie können keine Nachrichten mehr senden. Sie sind für den Chat verboten.",
    userBlockedSendMsg: "Sie können keine Nachrichten mehr senden. Sie sind für den Chat blockiert.",
    userBannedEditMsg: "Sie können keine Nachrichten mehr bearbeiten. Sie sind für den Chat verboten.",
    userBlockedEditMsg: "Sie können bearbeiten Nachrichten mehr senden. Sie sind für den Chat blockiert.",
    userBannedDeleteMsg: "Sie können keine Nachrichten mehr löschen. Sie sind für den Chat verboten.",
    userBlockedDeleteMsg: "Sie können löschen Nachrichten mehr senden. Sie sind für den Chat blockiert.",
    deleteChatMessage: "Sind Sie sicher, dass Sie diese Nachricht löschen wollen?",
    deleteChatMessageImg: "Möchten Sie dieses Bild wirklich löschen?",
    blockUserMsg: "Benutzer ist Blockiert!",
    hiddenmsg: "Diese Nachricht ist ausgeblendet",
    deletedmsg:"Diese Nachricht wird gelöscht",
    strDateJoin:'beigetreten',
    posts:'Beiträge',
    post:'Beitrag',
    Video:'Video',
    followers:'Abonnenten',
    following:'abonniert',
    ViewAll:'Alle ansehen',
    Comments:'Kommentare',
    Tweets:'Tweets',
    TweetsReplies:'Tweets & Antworten',
    Media:'Medien',
    warning: "Achtung!",
    uploadImgWarning: "Bild hochladen nur Apps übersetzen ",
    failedCptn: "Ist fehlgeschlagen, da ",
    loginBlockMsg: "Diese E-Mial-Adresse ist Blockiert!",
    userNotExists: "Benutzer existiert nicht!",
    userDiffEmail: "Verschiedene E-Mail-ID verwenden!",
    userAlrdyExists: "Benutzer existiert bereits!",
    codeSendSuccessMsg: "Bestätigungscode wurde gesendet an",
    codeErrorMsg: "Falscher Code",
    codeResendMsg: "Bitte prüfen oder den Code erneut senden",
    updateSuccessMsg: "Erfolgreich aktualisiert!",
    invalidEmailMsg: "Ungültige E-Mail",
    noResultMsg: "Keine weiteren Ergebnisse",
    enterCodeMsg: "Code eingeben",
    sentCode: "Gesendete code",
    sendCodeBtn: "Code Senden",
    verifyBtn: "Prüfen",
    backToRegisterBtn: "Zurück zu Registrieren",
    saveBtn: "Abspeichern",
    deleteBtn: "Löschen Sie ein Konto",
    alreadyRgstrBtn: "Bereits Registriert? Login",
    resendBtn: "zurücksenden",
    editMsgBtn: "Bearbeiten",
    deleteMsgBtn: "Löschen",
    noMoreFbCommentDataAvailable: "keine Daten mehr",
    noMoreTwitterDataAvailable: 'Keine weiteren Daten verfügbar',
    Photo:'Foto',
    gif:'GIF',
    networkErrorMsg: 'Die Internetverbindung ist langsam. Bitte überprüfen Sie die Internetverbindung, oder versuchen Sie es nach einiger Zeit erneut.',
    emptyChatRegisterErrorMsg: "Bitte melden Sie sich an um zu chatten, indem Sie auf die Schaltfläche senden klicken.",
    emptyChatErrorMsg: "Noch kein Gespräch!",
    fblinktext: 'Einen Link geteilt',
    fbabout: 'Über',
    fblikes:'Likes',
    fbsocialcountline: 'Personen gefällt das',
    fbcomments: 'kommentare',
    TagUserVideoHeading: 'In diesem Video',
    Retweeted:'retweetet',
    twitterfollowing: 'Folge ich',
    twitterfollowers: 'Follower',
    refresh:'Aktualisierung',
    errorCommentMessageValidUrl:'Bitte geben Sie eine gültige URL ein',
    noPageFound: 'Keine Seite gefunden',
    noInternetAccess: 'Keine Internetanbindung!',
    notweetFound:'Keine Tweets empfangen',
    errorfieldrequired:'Feld erforderlich!',
    strUhr: ' Uhr',
    strlimitimg: 'Es können nicht mehr als 15 Bilder gleichzeitig gesendet werden',
    str_justNow: "gerade eben",
    str_1_min: "vor 1 Minute",
    str_2_min: "vor 2 Minuten",
    str_3_min: "vor 3 Minuten",
    str_4_min: "vor 4 Minuten",
    str_5_min: "vor 5 Minuten",
    str_access_lock_heading: "Passwortschutz",
    str_access_lock_description: "Dieser Bereich ist Passwort geschützt, um die lnhalte zu sehen gib das Passwort ein.",
    str_btn_lock_unlock: "Entsperren",
    str_error_msg: "Das Passwort ist falsch, versuche es erneut.",
    str_entrpass : "Gib das Passwort ein",
    str_module_placeholde: "Dein Passwort",
    str_add_File: "Datei hinzufügen",
    str_file_upload: "Datei upload",
    str_file_error: "Dateiformat ist nicht korrekt",
    beforeterms: "Ich stimme diesen zu",
    termandcondtions: 'Nutzungsbedingungen zu.',
  },
  EN: {
    warning: "Warning",
    cancelBtn: 'Cancel',
    OkBtn: 'OK',
    uploadImgWarning: "Image upload work only compile Apps ",
    failedCptn: "Failed because : ",
    loginBlockMsg: "This Email-Id is Blocked!",
    userNotExists: "User does not exists!",
    userDiffEmail: "Use different Email Id!",
    userAlrdyExists: "User already exists!",
    codeSendSuccessMsg: "A Verification code has been sent to ",
    codeErrorMsg: "Wrong code",
    codeResendMsg: "Please check or resend code",
    networkErrorMsg: 'Network is slow. Please check Internet Connection or try after some time.',
    emptyChatRegisterErrorMsg: "Please Register/Login to chat by clicking on send button.",
    emptyChatErrorMsg: "No conversation yet!",
    invalidEmailMsg: "Invalid Email",
    noResultMsg: "No more results",
    enterCodeMsg: "Enter Code",
    sentCode: "Sent Code",
    sendCodeBtn: "Send Code",
    verifyBtn: "Verify",
    backToRegisterBtn: "Back To Register",
    updateSuccessMsg: "Updated successfully!",
    saveBtn: "Save",
    deleteBtn: "Delete an Account",
    alreadyRgstrBtn: "Already Registered ? LogIn",
    resendBtn: "Resend",
    editMsgBtn: "Edit",
    deleteMsgBtn: "Delete",
    backBtn: 'Back',
    closeBtn: 'Close',
    closethis: 'Close this',
    doneBtn:'Select',
    addCommentBtn: 'Write a Comment',
    beforeterms: 'I agree to these:',
    termandcondtions: 'Terms and Conditions.',
    comment: 'Comment',
    nameLbl: 'Name',
    emailLbl: 'Email',
    commentLbl: 'Write your comment here...',
    saveCommentbtn: 'Submit Comment',
    errorCommentTitle: 'PLEASE FILL OUT ALL FIELDS',
    errorCommentMessageName: 'Please enter your name',
    errorCommentMessageEmail: 'Please enter your email',
    errorCommentMessageValidEmail: 'Please enter a valid email!',
    errorCommentMessageValidPhone: 'Please enter a valid phone!',
    errorCommentMessageComment: 'Please enter a comment',
    succesCommentTitle: 'COMMENT HAS BEEN ADDED',
    succesCommentMessage: 'Your comment has been added successfully!',
    succesTitle: 'Success',
    succesMessage: 'Registered Successfully!',
    loginsuccesMessage: 'You logged in Successfully',
    registrationTitle: 'User Registration',
    userprofileTitle: 'User Profile',
    registrationBtn: 'Register',
    map: 'Map',
    list: 'List',
    sendMail: 'Send Email',
    startCall: 'Start Call',
    ofText: 'of',
    likeSuccesTitle: 'LIKE HAS BEEN ADDED',
    likeSuccesMessage: 'This content has been liked successfully!',
    disLikeSuccesTitle: 'LIKE HAS BEEN DELETED',
    disLikeSuccesMessage: 'Your like of this content has been removed successfully!',
    submitBtn: 'Submit',
    warningTitle: 'Device Simulator',
    warningMessage: 'This action can only be tested on a real device. For that reason just download the ON AIR Cockpit App on your device which you can find in your app store.' ,
    AppleDownload: 'Go to Apple App Store...',
    AndroidDownload: 'Go to Google Play Store...',
    readMoreBtn: 'Read More...',
    today: 'Today',
    yesterday: 'Yesterday',
    textInput:
    {
      "label": "text",
      "placeholder": "Enter your text here"
    },
    emailInput:
    {
      "label": "Email",
      "placeholder": "Enter your email here"
    },
    phoneInput:
    {
      "label": "Phone",
      "placeholder": "Enter your phone number here"
    },
    urlInput:
    {
      "label": "Website",
      "placeholder": "Enter your website URL here"
    },
    dateInput:
    {
      "label": "Date",
      "placeholder": "Please select a date here"
    },
    timeInput:
    {
      "label": "Time",
      "placeholder": "Please select a time here"
    },
    memoinput:
    {
      "label": "Your message",
      "placeholder": "Please enter your message here"
    },
    switchinput:
    {
      "label": "Please select:"
    },
    selectioninput:
    {
      "label": "Please select",
      "placeholder": "Click here to select"
    },
    checkboxinput:
    {
      "label": "Please select"
    },
    radioinput:
    {
      "label": "Please select"
    },
    strPostOn: 'Posted on',
    strReply: 'reply',
    strReplies: 'replies',
    strViews: 'views',
    strShow: 'Show',
    nofbdata: 'There are currently no FaceBook pages available',
    nofbcomments: 'There is no FaceBook comments',
    nowebsitedata: 'There are currently no websites available',
    norssdata: 'Currently no RSS fields are available',
    noyoutubedata: 'There are currently no channels available',
    strPastEvent: 'Past Appointments/Events',
    strFutureEvent: 'Future Appointments/Events',
    strCurrentEvent: 'Current Appointments/Events',
    RobotMessage1: "Welcome to Chat Module",
    RobotMessage2: "Hello",
    RobotMessage3: "Here you can see the chat messages of your users",
    sendmessageplaceholder: "Send message",
    userBannedSendMsg: "You can no longer send any message, You are ban for this chat.",
    userBlockedSendMsg: "You can no longer send any message, You are blocked for this chat.",
    userBannedEditMsg: "You can no longer edit any message, You are ban for this chat.",
    userBlockedEditMsg: "You can no longer edit any message, You are blocked for this chat.",
    userBannedDeleteMsg: "You can no longer delete any message, You are ban for this chat.",
    userBlockedDeleteMsg: "You can no longer delete any message, You are blocked for this chat.",
    deleteChatMessage: "Are you sure you want to delete this message?",
    deleteChatMessageImg: "Are you sure you want to delete this Image?",
    blockUserMsg: "User is Blocked!",
    hiddenmsg: "this message is hidden",
    deletedmsg:"this message is deleted",
    strDateJoin:"Joined",
    posts:"Posts",
    post:"Post",
    Video:'Video',
    followers:"Followers",
    following:"Following",
    ViewAll:"View All",
    Comments:"Comments",
    Tweets:"Tweets",
    TweetsReplies:'Tweets & replies',
    Media:'Media',
    noMoreFbCommentDataAvailable: "No more data",
    noMoreTwitterDataAvailable: 'No more data available',
    Photo:'Photo',
    gif:'GIF',
    fblinktext: 'shared a link',
    fbabout: 'About',
    fblikes:'Likes',
    fbsocialcountline: 'People like that',
    fbcomments: 'Comments',
    TagUserVideoHeading: 'In This Video',
    Retweeted:'Retweeted',
    twitterfollowing: 'Following',
    twitterfollowers: 'Followers',
    refresh:'Refresh',
    errorCommentMessageValidUrl: 'Please enter a valid url!',
    noPageFound: 'No Page provided',
    noInternetAccess: 'No Network Access!',
    notweetFound:'No tweets received',
    errorfieldrequired:'field required!',
    strUhr:" o'clock",
    strlimitimg: "can't send more than 15 image at a once",
    str_justNow: "just now",
    str_1_min: "1 minute ago",
    str_2_min: "2 minute ago",
    str_3_min: "3 minute ago",
    str_4_min: "4 minute ago",
    str_5_min: "5 minute ago",
    str_access_lock_heading: "Password Protection",
    str_access_lock_description: "This area is password protected, to see the contents enter the password",
    str_btn_lock_unlock: "unlock",
    str_error_msg: "The password is wrong, try it again.",
    str_entrpass: "Enter the password",
    str_module_placeholde: "Your Password",
    str_add_File: "Add File",
    str_file_upload: "File Upload",
    str_file_error: "File format is not correct"
  }
}

export const getResource = (lang) => {
  return languageResource[lang.toUpperCase()]
}



// WEBPACK FOOTER //
// ./src/lang.js